<template>
    <div class="body">
        <div class="top-box-top">
            <top />
        </div>
        <div class="bottom-box">
            <basecom />
            <div class="list">
                <div class="medical-list">
                    <div class="search">
                    <userSearch
                    :search="search"
                    :reset="reset"
                    :numTotal="numTotal"
                    ></userSearch>
                    </div>
                    <userlist
                    :header-cell-style="{ 
                    background:'#000',color:'#fff'}"
                    :tableHeader="this.userlogic.listHeader()"
                    :tableData="userList"
                    :page="this.userlogic.searchObj.page"
                    :row-class-name="tableRowClassName"
                    ></userlist>
                    <pager
                    :page="this.userlogic.searchObj.page"
                    :numTotal="numTotal"
                    :handleCurrentChange="handleCurrentChange"
                    >
                    </pager>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import basecom from "@/components/base";
import top from "@/components/top";
import userlist from "@/components/listComponents/pagerList";
import pager from "@/components/listComponents/pager.vue";
import userSearch from "@/components/searchComponents/userSearch.vue";
export default {
    components: {
        basecom,
        userlist,
        pager,
        userSearch,
        top
    },
    data() {
        return {
            userList: [],
            page: 1,
            numTotal: 0,
        };
    },
    mounted() {
        this.search();
    },
    methods: {
        tableRowClassName({row, rowIndex}) {
            if(rowIndex%2==1){
                return 'warning-row';
            }else{
                return 'success-row';
            }
        },
        handleCurrentChange: function (page = 1) {
            this.userlogic.searchObj.page = page;
            this.userlogic.getUserList().then((res) => {
                this.userList = res.userList;
                this.numTotal = res.total;
            });
        },
        reset() {
            window.location.reload()
        },
        search() {
            this.handleCurrentChange();
        },
    },
    };
</script>